namespace RioERP.Orders {
    export interface InstamojoSettingsForm {
        ClientId: Serenity.StringEditor;
        ClientSecret: Serenity.StringEditor;
        WebhookUrl: Serenity.StringEditor;
        RedirectUrl: Serenity.StringEditor;
        TransactionIdPrefix: Serenity.StringEditor;
        Currency: Serenity.EnumEditor;
    }

    export class InstamojoSettingsForm extends Serenity.PrefixedContext {
        static formKey = 'Orders.InstamojoSettings';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!InstamojoSettingsForm.init)  {
                InstamojoSettingsForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.EnumEditor;

                Q.initFormType(InstamojoSettingsForm, [
                    'ClientId', w0,
                    'ClientSecret', w0,
                    'WebhookUrl', w0,
                    'RedirectUrl', w0,
                    'TransactionIdPrefix', w0,
                    'Currency', w1
                ]);
            }
        }
    }
}
